import { render, staticRenderFns } from "./HistoryRemark.vue?vue&type=template&id=d29cab60"
import script from "./HistoryRemark.vue?vue&type=script&lang=js"
export * from "./HistoryRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports